module.exports = __webpack_public_path__ + "img/shenpizhong.2c1ab092.png";